import React from 'react';
import styles from './TablePanelHeader.module.scss';

type TablePanelHeaderProps = {
  title?: string;
  subtitle?: string;
  status?: boolean;
};

export const TablePanelHeader = ({ title, subtitle, status }: TablePanelHeaderProps) => {
  return (
    <div className={styles['panel-header-wrapper']}>
      <span className={styles['panel-header-title']}>{title}</span>
      <span className={styles['panel-header-subtitle']}>{subtitle}</span>
      <span className={styles['panel-header-status']}>{status ? 'Fechar' : 'Abrir'}</span>
    </div>
  );
};
